// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/microscope.js';

import { paths } from '../generated/microscope';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('microscope', Original, paths);
